// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.PatientReferralRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientReferralRequest extends GandalfModelBase {

	@GandalfLabel('Referral Comments')
	@GandalfValidator({ sizeString: { message: 'Referral Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('Incentive Program')
	@GandalfProperty({ designType: Number })
	incentiveProgramId!: number | null;

	@GandalfLabel('Incentive Sent Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	incentiveSentDate!: Date | null;

	@GandalfLabel('Referral Date')
	@GandalfValidator({ notNull: { message: 'Referral Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	referralDate!: Date;

	@GandalfLabel('Referring Patient')
	@GandalfProperty({ designType: Number })
	referringPatientId!: number | null;

	@GandalfLabel('Referring Provider')
	@GandalfProperty({ designType: Number })
	referringProviderId!: number | null;

	@GandalfLabel('Other Source')
	@GandalfProperty({ designType: Number })
	sourceId!: number | null;

	@GandalfConstantDecorator(constants.PatientReferralSourceType)
	@GandalfLabel('Source')
	@GandalfProperty({ designType: constants.PatientReferralSourceType })
	sourceType!: constants.PatientReferralSourceType | null;

}
